<div class="ion-padding">
  <ion-card>
    <ion-card-header>
      <ion-card-title>MinIO tárhely (fájltárolás) beállításai</ion-card-title>
      <ion-card-subtitle>
        A fájltárolás (sablonok, feltöltések, tanúsítványok) kapcsolódási adatai. Mentés után azonnal
        élesedik, kód-deploy nélkül.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <ion-progress-bar type="indeterminate" *ngIf="loading"></ion-progress-bar>

      <ion-item lines="none">
        <ion-label>
          Jelenlegi forrás:
          <ion-badge [color]="forras === 'db' ? 'success' : 'medium'">
            {{ forras === 'db' ? 'Adatbázis (egyedi)' : 'Alapértelmezett (kód)' }}
          </ion-badge>
        </ion-label>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Végpont (host)</ion-label>
        <ion-input [(ngModel)]="settings.endPoint" placeholder="pl. minio vagy minio.pelda.hu"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Port</ion-label>
        <ion-input type="number" [(ngModel)]="settings.port" placeholder="9000"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label>HTTPS (SSL)</ion-label>
        <ion-toggle slot="end" [(ngModel)]="settings.useSSL"></ion-toggle>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Access Key</ion-label>
        <ion-input [(ngModel)]="settings.accessKey" placeholder="MinIO access key"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">
          Secret Key
          <span *ngIf="hasSecret" style="color:#888"> (jelenleg beállítva: {{ secretMask }})</span>
        </ion-label>
        <ion-input
          type="password"
          [(ngModel)]="settings.secretKey"
          placeholder="Hagyd üresen, ha nem változtatod"
        ></ion-input>
      </ion-item>

      <ion-item>
        <ion-label position="stacked">Alapértelmezett bucket</ion-label>
        <ion-input [(ngModel)]="settings.bucket" placeholder="sulinform"></ion-input>
      </ion-item>

      <div style="display:flex; gap:8px; margin-top:16px; flex-wrap:wrap">
        <ion-button color="success" (click)="saveSettings()" [disabled]="saving || loading">
          <ion-icon slot="start" name="save-outline"></ion-icon>
          Mentés és élesítés
        </ion-button>
        <ion-button fill="outline" (click)="testConnection()" [disabled]="testing || loading">
          <ion-icon slot="start" name="pulse-outline"></ion-icon>
          Kapcsolat tesztelése
        </ion-button>
        <ion-button fill="clear" color="medium" (click)="loadSettings()" [disabled]="loading">
          Újratöltés
        </ion-button>
      </div>

      <ion-item lines="none" *ngIf="tesztEredmeny" style="margin-top:12px">
        <ion-icon
          slot="start"
          [name]="tesztEredmeny.ok ? 'checkmark-circle' : 'close-circle'"
          [color]="tesztEredmeny.ok ? 'success' : 'danger'"
        ></ion-icon>
        <ion-label class="ion-text-wrap">
          {{ tesztEredmeny.uzenet }}
          <p *ngIf="tesztEredmeny.bucketok?.length">Elérhető bucketök: {{ tesztEredmeny.bucketok.join(', ') }}</p>
        </ion-label>
      </ion-item>

      <ion-note color="medium" style="display:block; margin-top:12px; font-size:12px">
        Megjegyzés: a Secret Key biztonsági okból sosem jelenik meg teljes egészében. Üres Secret mezővel
        a korábban mentett kulcs marad érvényben.
      </ion-note>
    </ion-card-content>
  </ion-card>
</div>
